import { baseURLIdentifiers } from "../constants/baseURLIdentifiers";

export const config = {
  [baseURLIdentifiers.PRODUCT_SERVICE]: "https://api.zcommerce.crio.do",
  [baseURLIdentifiers.ORDER_SERVICE]: "https://api.zcommerce.crio.do",
  [baseURLIdentifiers.AUTH_SERVICE]: "https://auth.zcommerce.crio.do",
  [baseURLIdentifiers.USER_SERVICE]: "https://api.zcommerce.crio.do",
};
